var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzureDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_504_11656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4458 12.0628H48.1502L29.7713 67.0001C29.5824 67.5646 29.2228 68.0552 28.7431 68.4027C28.2633 68.7502 27.6877 68.9372 27.0971 68.9373H13.3187C12.8712 68.9374 12.4302 68.8299 12.032 68.6239C11.6339 68.4179 11.2901 68.1191 11.0291 67.7525C10.7681 67.3858 10.5974 66.9617 10.5311 66.5152C10.4648 66.0688 10.5048 65.6128 10.6479 65.1851L27.7709 14C27.9597 13.4352 28.3194 12.9445 28.7993 12.5968C29.2791 12.2492 29.855 12.0622 30.4458 12.0621V12.0628Z",
    fill: "#0B5CA6",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1731 48.9105H28.0982C27.8372 48.9102 27.5822 48.9892 27.3663 49.1372C27.1505 49.2853 26.9838 49.4955 26.888 49.7404C26.7923 49.9854 26.7719 50.2538 26.8294 50.5106C26.887 50.7674 27.02 51.0008 27.2109 51.1803L45.2512 68.1677C45.7764 68.662 46.468 68.9368 47.1863 68.9367H63.0834L56.1731 48.9105Z",
    fill: "#0078D4",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4469 12.0625C29.8496 12.0601 29.2673 12.2506 28.785 12.6059C28.3026 12.9612 27.9455 13.4628 27.7659 14.0374L10.67 65.1381C10.5174 65.5674 10.4694 66.0274 10.5303 66.4794C10.5912 66.9313 10.759 67.3618 11.0197 67.7345C11.2803 68.1071 11.6261 68.4109 12.0278 68.6203C12.4294 68.8296 12.8752 68.9382 13.3272 68.937H27.4612C27.9876 68.8421 28.4797 68.6079 28.887 68.2584C29.2944 67.9089 29.6025 67.4566 29.7798 66.9477L33.1891 56.8111L45.3669 68.2702C45.8772 68.6961 46.5174 68.9315 47.1796 68.937H63.0175L56.0712 48.9107L35.8218 48.9155L48.2152 12.0625H30.4469Z",
    fill: "url(#paint0_linear_504_11656)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0578 13.9969C52.8692 13.4331 52.5101 12.9431 52.0309 12.5961C51.5518 12.2491 50.9768 12.0624 50.387 12.0625H30.6557C31.2455 12.0625 31.8204 12.2492 32.2996 12.5962C32.7787 12.9433 33.1379 13.4331 33.3265 13.9969L50.4502 65.1841C50.5933 65.6119 50.6335 66.0679 50.5672 66.5145C50.501 66.9611 50.3303 67.3853 50.0693 67.7521C49.8083 68.119 49.4645 68.4178 49.0663 68.624C48.6681 68.8301 48.227 68.9377 47.7794 68.9377H67.5113C67.9589 68.9376 68.3999 68.8299 68.798 68.6237C69.1961 68.4175 69.5399 68.1187 69.8008 67.7519C70.0617 67.3851 70.2323 66.9609 70.2985 66.5143C70.3647 66.0678 70.3246 65.6118 70.1815 65.1841L53.0578 13.9969Z",
    fill: "url(#paint1_linear_504_11656)",
    stroke: "none"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_504_11656",
    x1: 42.643,
    y1: 41.8151,
    x2: 38.3823,
    y2: 43.2431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_504_11656",
    x1: 40.302,
    y1: 14.6788,
    x2: 60.7991,
    y2: 68.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_504_11656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(10.5 10.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureDark);
export default __webpack_public_path__ + "static/media/azure-dark.749517adaff8016e2166ea6187826e39.svg";
export { ForwardRef as ReactComponent };